module.exports = __webpack_public_path__ + "static/img/10.20c84d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/sp/10.png
// module id = r4VK
// module chunks = 0